
<div class="StoltBGDefault">
<div class="container-stolt">

  <div class="BrandAreaTop"> 
      <div class="headerAreabrnd">
        <img class="BrandLogo" src="assets/images/ST_LOGO_1.svg">
        <em></em>
        <span class="font-family02"><b>Supply forecasting</b></span>  
      </div>
      <div class="LastUpdateCol">
        <span>
          <span class="Last_updatedTxt">Last updated:</span>
          <span class="bold_detail"> {{lastUpdatedDate}}</span>
        </span>
      </div> 
  </div> 

<div class="StoltCommonContentArea">
  <div class="RegionRecentArea">
    <div class="RegionColumn">
      <h6 class="common-heading-bold">Region</h6> 
      <div class="ButtonTagsCol TagsButtonHolder RegionSelect ScrollhostSpaceHide">
        <!-- <button [ngClass]="{active: regionType == '1'}" (click)="selectRegion(1)">Region 1</button> 
        <button [ngClass]="{active: regionType == '2'}" (click)="selectRegion(2)">Region 2</button>
        <button [ngClass]="{active: regionType == '3'}" (click)="selectRegion(3)">Region 3</button>  
        <button [ngClass]="{active: regionType == '4'}" (click)="selectRegion(4)">Region 4</button> -->
        <ng-select *ngIf="!showRegionSkel" [(ngModel)]="regionFilterValue" (change)="inprogressFilterChange('region')" [searchable]="true" [clearable]="true">
          <ng-option *ngFor="let d of regionArrayData" [value]="d.key">
          {{d.key}}
          </ng-option>
        </ng-select>
        <div class="Stolt-Skeleton" *ngIf="showRegionSkel"></div>
      </div>  


      <div class="DateRangeArea">
        <h6 class="common-heading-bold">Laycan window</h6>  
        <div class="ColumnDateRange">
          <div class="ButtonTagsCol TagsButtonHolder"> 
            <!--<span class="DateTitle">Preset range from today:</span>-->
            <div class="ButtonInnerTgs">
              <button [ngClass]="{active: weekType == '0'}" (click)="selectWeek(0)">Now</button> 
              <!-- <button [ngClass]="{active: weekType == '1'}" (click)="selectWeek(1)">1 week</button> 
              <button [ngClass]="{active: weekType == '2'}" (click)="selectWeek(2)">2 week</button> 
              <button [ngClass]="{active: weekType == '3'}" (click)="selectWeek(3)">3 week</button> 
              <button [ngClass]="{active: weekType == '4'}" (click)="selectWeek(4)">4 week</button>  -->
            </div>
          </div>   
          <div class="ButtonTagsCol TagsButtonHolder"> 
           <!-- <span class="DateTitle">Custom date range:</span>-->
            <!-- <div class="ButtonInnerTgs"> 
              <button>01 Feb 2022 - 31 Mar 2022</button> 
            </div> -->
            <div class="date CustomDatePicker">
              <mat-form-field appearance="outline">
                <mat-label>Select date range</mat-label>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
                <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="minDate">
                  <input matStartDate formControlName="start" placeholder="Start date" #dateRangeStart>
                  <input matEndDate formControlName="end" placeholder="End date" #dateRangeEnd
                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                </mat-date-range-input>
              </mat-form-field>
            </div>
          </div> 
        </div> 
      </div>
    </div>

    <div class="RecentColumn">
      <div class="RecentColumnInner">
      <h6 class="common-heading-bold">Recent <span><a href="javascript:void(0)" (click)="clearRecent()">Clear Recent</a></span></h6>  
   
      <ul> 
        <li *ngIf="!recent || !recent.length">No Recent History</li>
        <li *ngFor="let i of recent"><a href="javascript:void(0)" (click)="recentClickEvent(i)">{{i}}</a></li>
      </ul>
      </div>
    </div>

  </div>
 
 
  <div class="FilterTableSec">
    <div class="TableTitleHolder">
      <h3 class="common-heading-bold">Competitor Vessels</h3> 
      <div class="TabelViewChangers"> 
        <span [ngClass]="{mapActive: !mapView}" (click)="switchMapView(false)">
         <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M6.66663 5H17.5" stroke="#008ECF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M6.66663 10H17.5" stroke="#008ECF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M6.66663 15H17.5" stroke="#008ECF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M2.5 5H2.51" stroke="#008ECF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M2.5 10H2.51" stroke="#008ECF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M2.5 15H2.51" stroke="#008ECF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
         </svg>             
        </span>
        <span [ngClass]="{mapActive: mapView}" (click)="switchMapView(true)" >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.83325 5.60075V17.3367L6.96775 14.4027L12.8357 17.3367L17.9702 14.4027V2.66675L12.8357 5.60075L6.96775 2.66675L1.83325 5.60075Z" stroke="#008ECF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.96777 2.66675V14.4027" stroke="#008ECF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.8357 5.60083V17.3368" stroke="#008ECF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>   
        </span>
      </div>
     </div>
    
    
    <div class="app-table-holder" *ngIf="isChecked===false">
         <div class="TableFilterSection"> 
          <!--<span class="FiltersTitle">Basic Filters:</span>-->
           <div class="FilterDropDownAreaHld"> 
           <div class="FilterDropDownArea"> 
             <div class="AllFilters" [ngClass]="isClearFilter == '0' ? 'disabledHLd' : 'active'">
               <span>
                <!--<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.5" d="M3.5 9.5H10.5C10.75 9.5 11 9.28125 11 9V7C11 6.75 10.75 6.5 10.5 6.5H3.5C3.21875 6.5 3 6.75 3 7V9C3 9.28125 3.21875 9.5 3.5 9.5ZM12.5 2H11V0.5C11 0.25 10.75 0 10.5 0H9.5C9.21875 0 9 0.25 9 0.5V2H5V0.5C5 0.25 4.75 0 4.5 0H3.5C3.21875 0 3 0.25 3 0.5V2H1.5C0.65625 2 0 2.6875 0 3.5V14.5C0 15.3438 0.65625 16 1.5 16H12.5C13.3125 16 14 15.3438 14 14.5V3.5C14 2.6875 13.3125 2 12.5 2ZM12.5 14.3125C12.5 14.4375 12.4062 14.5 12.3125 14.5H1.6875C1.5625 14.5 1.5 14.4375 1.5 14.3125V5H12.5V14.3125Z" fill="#008ECF"/>
                </svg> -->                  
                Filters
               </span>
               <a href="javascript:void(0)"  (click)="onClearFilters()">Reset Filters</a>
             </div>
             <div class="form-row ngx-slider-row position-relative">
              <!--  <div class="form-group position-relative">
                 <span class="StaticName">Confidence:</span> 
                 <ng-select class="TextSlectGroup ConfidenceFilterValue" [(ngModel)]="confidenceFilterValue" (change)="inprogressFilterChange('confidence')" [searchable]="true" [clearable]="true">
                  <ng-option *ngFor="let d of confidenceArrayData" [value]="d.value">
                   {{d.key}}
                 </ng-option>
                </ng-select>
               </div> -->
               <!--
               <ngx-slider class="Filter-ngx" [(value)]="minValue" [(highValue)]="maxValue" [options]="options" (userChangeEnd)="inprogressFilterChange('confidence')"></ngx-slider>
               <span class="ConfidenceTxt">Confidence</span>-->

              
               <div class="ConfidenceFltrSlider" id="confidenceId2" [ngClass]="{'active':isConfidenceClicked}" (click)="toggleSlider('confidence',$event);">
                 <span>Confidence: 
                  <span class="valuespan" *ngIf="minValue == 0 && maxValue == 100">0-100</span>
                  <span class="valuespan" *ngIf="minValue != 0 || maxValue != 100">{{minValue}}-{{maxValue}}</span>
                </span>
               </div>
               <div class="Confidencedropdown" id="confidenceId" [ngClass]="{'active':isConfidenceClicked}">
                  <div class="ConfidenceBdy">
                    <span class="TitleConf">Confidence</span>
                    <div class="DragSliderHld">
                      <ngx-slider class="Filter-ngx" [(value)]="minValue" [(highValue)]="maxValue" [options]="options"></ngx-slider>
                    </div>
                  </div> 
                  <div class="Confidencedropftr">
                      <button class="StoltBtnIconLarge position-relative overflow-hidden" (click)="inprogressFilterChange('confidence')">Apply</button>
                      <button class="StoltBtnIconLarge StoltBtnBorderOnly" (click)="resetSlider('confidence')">Reset</button>
                  </div>
               </div>
               
             </div>
             <div class="form-row">
              <div class="form-group position-relative">
                <!--<span class="StaticName">Vessel:</span> 
                 <ng-select class="TextSlectGroup VesselFilterValue" [closeOnSelect]="false" [(ngModel)]="vesselFilterValue" (change)="inprogressFilterChange('vessel')" [searchable]="true" [clearable]="true">
                    <ng-option [value]="" selected>All</ng-option>
                    <ng-option *ngFor="let d of vesselArrayData" [value]="d">
                    {{d}} 
                  </ng-option>
                  
                 </ng-select>-->
                 
                 <!-- <ng-multiselect-dropdown name="vessel" ngDefaultControl
                 [placeholder]="'Vessel:'"
                 [settings]="dropdownSettings"
                 [data]="vesselArrayData"
                 [(ngModel)]="selectedItems"
                 (onSelect)="onItemSelect($event,'vs')"
                 (onSelectAll)="onSelectAll($event,'vs')"
                 (onDeSelectAll)="onDeSelectAll($event,'vs')"
                 (onDeSelect)="onDeSelect($event,'vs')">
               </ng-multiselect-dropdown> -->
               <ng-select #ngSelectControlVessal [items]="vesselArrayData" [multiple]="true"
                      class="TextSlectGroup _Vessel inputHiddein" [searchable]="false" [clearable]="false"
                      bindLabel="vesselName" [closeOnSelect]="false" bindValue="vesselName"
                      [(ngModel)]="vesselFilterValueTemp" groupBy="vessel" [selectableGroup]="true" placeholder="All"
                      (open)="vesselFilterValueTemp=vesselFilterValue" (close)="vesselFilterValueTemp=vesselFilterValue"
                      >
                      <ng-template ng-multi-label-tmp let-items="items">
                          <span *ngIf="items.length < 2 && !items[0].hasOwnProperty('vesselName')">{{ items[0]?.vessel|titlecase}}</span>
                          <span *ngIf="items.length < 2 && items[0].hasOwnProperty('vesselName')">{{items[0]?.vesselName|titlecase}}</span>
                          <span *ngIf="items.length >= 2">{{items.length}}</span>
                          <!-- <span *ngIf="items.length >= 1 && items.length ===vesselFilterData.length"> All</span> -->
                      </ng-template>
                      <ng-template ng-header-tmp>
                          <input style="width: 100%; line-height: 24px" type="text" placeholder="Search vessel names"
                              (input)="customSearch('vessel',$event)" />
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$"
                          let-index="index"> 
                          <div class="checkboxHld">
                              <label class="containerCheckbx">
                                  <input type="checkbox" id="item-{{index}}" [ngModel]="item$.selected"/>
                                  <span class="checkmark"></span>
                              </label>
                              <span class="OptionTxt">{{item.vesselName|titlecase}}</span>
                          </div> 
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" >
                          <div class="SelectAllOpt"  [style.display]="hideAllVessalSearch ? 'flex' : 'none'">
                          <div class="checkboxHld">
                              <label class="containerCheckbx">
                                  <input id="item-{{index}}" type="checkbox"
                                  [ngModel] ="item$.selected"/>
                                  <span class="checkmark"></span>
                              </label>
                              <span class="OptionTxt">All ({{vesselArrayData.length}})</span>
                          </div> 
                      </div>
                        </ng-template>
                      <ng-template ng-footer-tmp>
                          <button class="StoltBtnIconLarge position-relative overflow-hidden" (click)="submitFilterMultiple('vessel')" [disabled]="vesselFilterValueTemp.length === 0">Apply</button>
                          <button class="StoltBtnIconLarge StoltBtnBorderOnly" (click)="resetFilterMultiple('vessel')">Reset</button>
                      </ng-template>
                  </ng-select>
               </div>
             </div>
             <div class="form-row">
              <div class="form-group position-relative">
                <!--<span class="StaticName">Operator:</span> 
                   <ng-select class="TextSlectGroup OperatorFilterValue" [(ngModel)]="operatorFilterValue" (change)="inprogressFilterChange('operator')" [searchable]="true" [clearable]="true">
                     <ng-option [value]="" selected>All</ng-option>
                     <ng-option *ngFor="let d of operatorArrayData" [value]="d">
                     {{d}}
                   </ng-option>
                  </ng-select>-->

                  <!-- <ng-multiselect-dropdown name="operator" ngDefaultControl
                  [placeholder]="'Operator:'"
                  [settings]="dropdownSettings"
                  [data]="operatorArrayData"
                  [(ngModel)]="selectedItemsOperator"
                  (onSelect)="onItemSelect($event,'op')"
                  (onSelectAll)="onSelectAll($event,'op')"
                  (onDeSelectAll)="onDeSelectAll($event,'op')"
                  (onDeSelect)="onDeSelect($event,'op')">
                </ng-multiselect-dropdown> -->
                <ng-select #ngSelectControlOperator [items]="operatorArrayData" [multiple]="true"
                      class="TextSlectGroup _Operators inputHiddein" [searchable]="false" [clearable]="false"
                      bindLabel="operatorName" [closeOnSelect]="false" bindValue="operatorName"
                      [(ngModel)]="operatorFilterValueTemp" groupBy="operator" [selectableGroup]="true" placeholder="All"
                      (open)="operatorFilterValueTemp=operatorFilterValue" (close)="operatorFilterValueTemp=operatorFilterValue"
                      >
                      <ng-template ng-multi-label-tmp let-items="items">
                          <span *ngIf="items.length < 2 && !items[0].hasOwnProperty('operatorName')">{{ items[0]?.operator|titlecase}}</span>
                          <span *ngIf="items.length < 2 && items[0].hasOwnProperty('operatorName')">{{items[0]?.operatorName|titlecase}}</span>
                          <span *ngIf="items.length >= 2">{{items.length}}</span>
                          <!-- <span *ngIf="items.length >= 1 && items.length ===vesselFilterData.length"> All</span> -->
                      </ng-template>
                      <ng-template ng-header-tmp>
                          <input style="width: 100%; line-height: 24px" type="text" placeholder="Search operator names"
                              (input)="customSearch('operator',$event)" />
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$"
                          let-index="index"> 
                          <div class="checkboxHld">
                              <label class="containerCheckbx">
                                  <input type="checkbox" id="item-{{index}}" [ngModel]="item$.selected"/>
                                  <span class="checkmark"></span>
                              </label>
                              <span class="OptionTxt">{{item.operatorName|titlecase}}</span>
                          </div> 
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" >
                          <div class="SelectAllOpt"  [style.display]="hideAllOperatorSearch ? 'flex' : 'none'">
                          <div class="checkboxHld">
                              <label class="containerCheckbx">
                                  <input id="item-{{index}}" type="checkbox"
                                  [ngModel] ="item$.selected"/>
                                  <span class="checkmark"></span>
                              </label>
                              <span class="OptionTxt">All ({{operatorArrayData.length}})</span>
                          </div> 
                      </div>
                        </ng-template>
                      <ng-template ng-footer-tmp>
                          <button class="StoltBtnIconLarge position-relative overflow-hidden" (click)="submitFilterMultiple('operator')" [disabled]="operatorFilterValueTemp.length === 0">Apply</button>
                          <button class="StoltBtnIconLarge StoltBtnBorderOnly" (click)="resetFilterMultiple('operator')">Reset</button>
                      </ng-template>
                  </ng-select>
               </div>
             </div>
             <div class="form-row">
              <div class="form-group position-relative">
                <!-- <span class="StaticName">DWT:</span> 
               <ng-select class="TextSlectGroup DWTFilterValue ng-select-large ng-select-md" [(ngModel)]="dwtFilterValue" (change)="inprogressFilterChange('dwt')" [searchable]="true" [clearable]="true">
                <ng-option *ngFor="let d of dwtArrayData" [value]="d.value">
                 {{d.key}}
               </ng-option>
              </ng-select> -->
              <ng-select #ngSelectControlDwt [items]="dwtArrayData" [multiple]="true"
                    class="TextSlectGroup _DWT inputHiddein" [searchable]="false" [clearable]="false"
                    bindLabel="dwtName" [closeOnSelect]="false" bindValue="dwtCode"
                    [(ngModel)]="dwtFilterValueTemp" groupBy="dwt" [selectableGroup]="true" placeholder="All"
                    (open)="dwtFilterValueTemp=dwtFilterValue" (close)="dwtFilterValueTemp=dwtFilterValue"
                    >
                    <ng-template ng-multi-label-tmp let-items="items">
                        <span *ngIf="items.length < 2 && !items[0].hasOwnProperty('dwtName')">{{ items[0]?.dwt|titlecase}}</span>
                        <span *ngIf="items.length < 2 && items[0].hasOwnProperty('dwtName')">{{items[0]?.dwtName|titlecase}}</span>
                        <span *ngIf="items.length >= 2">{{items.length}}</span>
                        <!-- <span *ngIf="items.length >= 1 && items.length ===vesselFilterData.length"> All</span> -->
                    </ng-template>
                    <ng-template ng-header-tmp>
                        <input style="width: 100%; line-height: 24px" type="text" placeholder="Search dwt"
                            (input)="customSearch('dwt',$event)" />
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-item$="item$"
                        let-index="index"> 
                        <div class="checkboxHld">
                            <label class="containerCheckbx">
                                <input type="checkbox" id="item-{{index}}" [ngModel]="item$.selected"/>
                                <span class="checkmark"></span>
                            </label>
                            <span class="OptionTxt">{{item.dwtName|titlecase}}</span>
                        </div> 
                    </ng-template>
                    <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" >
                        <div class="SelectAllOpt"  [style.display]="hideAllDwtSearch ? 'flex' : 'none'">
                        <div class="checkboxHld">
                            <label class="containerCheckbx">
                                <input id="item-{{index}}" type="checkbox"
                                [ngModel] ="item$.selected"/>
                                <span class="checkmark"></span>
                            </label>
                            <span class="OptionTxt">All ({{dwtArrayData.length}})</span>
                        </div> 
                    </div>
                      </ng-template>
                    <ng-template ng-footer-tmp>
                        <button class="StoltBtnIconLarge position-relative overflow-hidden" (click)="submitFilterMultiple('dwt')" [disabled]="dwtFilterValueTemp.length === 0">Apply</button>
                        <button class="StoltBtnIconLarge StoltBtnBorderOnly" (click)="resetFilterMultiple('dwt')">Reset</button>
                    </ng-template>
                </ng-select>
               </div>
             </div>
             <div class="form-row">
              <div class="form-group position-relative">
                <!-- <span class="StaticName">DWT:</span> 
               <ng-select class="TextSlectGroup DWTFilterValue ng-select-large ng-select-md" [(ngModel)]="dwtFilterValue" (change)="inprogressFilterChange('dwt')" [searchable]="true" [clearable]="true">
                <ng-option *ngFor="let d of dwtArrayData" [value]="d.value">
                 {{d.key}}
               </ng-option>
              </ng-select> -->
              <ng-select #ngSelectControlTankType [items]="tankTypeArrayData" [multiple]="true"
                    class="TextSlectGroup _tanktype inputHiddein" [searchable]="false" [clearable]="false"
                    bindLabel="tankTypeName" [closeOnSelect]="false" bindValue="tankTypeName"
                    [(ngModel)]="tankTypeFilterValueTemp" groupBy="tankType" [selectableGroup]="true" placeholder="All"
                    (open)="tankTypeFilterValueTemp=tankTypeFilterValue" (close)="tankTypeFilterValueTemp=tankTypeFilterValue"
                    >
                    <ng-template ng-multi-label-tmp let-items="items">
                        <span *ngIf="items.length < 2 && !items[0].hasOwnProperty('tankTypeName') ">{{ items[0]?.tankType|titlecase}}</span>
                        <span *ngIf="items.length < 2 && items[0].hasOwnProperty('tankTypeName')">{{items[0]?.tankTypeName|titlecase}}</span>
                        <span *ngIf="items.length >= 2">{{items.length}}</span>
                        <!-- <span *ngIf="items.length >= 1 && items.length ===vesselFilterData.length"> All</span> -->
                    </ng-template>
                    <ng-template ng-header-tmp>
                        <input style="width: 100%; line-height: 24px" type="text" placeholder="Search Tank Type"
                            (input)="customSearch('tankType',$event)" />
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-item$="item$"
                        let-index="index"> 
                        <div class="checkboxHld">
                            <label class="containerCheckbx">
                                <input type="checkbox" id="item-{{index}}" [ngModel]="item$.selected"/>
                                <span class="checkmark"></span>
                            </label>
                            <span class="OptionTxt">{{item.tankTypeName|titlecase}}</span>
                        </div> 
                    </ng-template>
                    <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" >
                        <div class="SelectAllOpt"  [style.display]="hideAllTankTypeSearch ? 'flex' : 'none'">
                        <div class="checkboxHld">
                            <label class="containerCheckbx">
                                <input id="item-{{index}}" type="checkbox"
                                [ngModel] ="item$.selected"/>
                                <span class="checkmark"></span>
                            </label>
                            <span class="OptionTxt">All ({{tankTypeArrayData.length}})</span>
                        </div> 
                    </div>
                      </ng-template>
                    <ng-template ng-footer-tmp>
                        <button class="StoltBtnIconLarge position-relative overflow-hidden" (click)="submitFilterMultiple('tankType')" [disabled]="tankTypeFilterValueTemp.length === 0">Apply</button>
                        <button class="StoltBtnIconLarge StoltBtnBorderOnly" (click)="resetFilterMultiple('tankType')">Reset</button>
                    </ng-template>
                </ng-select>
               </div>
             </div>
             <div class="form-row ngx-slider-row position-relative">
              <!--  <div class="form-group position-relative">
                 <span class="StaticName">Confidence:</span> 
                 <ng-select class="TextSlectGroup ConfidenceFilterValue" [(ngModel)]="confidenceFilterValue" (change)="inprogressFilterChange('confidence')" [searchable]="true" [clearable]="true">
                  <ng-option *ngFor="let d of confidenceArrayData" [value]="d.value">
                   {{d.key}}
                 </ng-option>
                </ng-select>
               </div> -->
               <!--
               <ngx-slider class="Filter-ngx" [(value)]="minValue" [(highValue)]="maxValue" [options]="options" (userChangeEnd)="inprogressFilterChange('confidence')"></ngx-slider>
               <span class="ConfidenceTxt">Confidence</span>-->

              
               <div class="ConfidenceFltrSlider" id="ageId2" [ngClass]="{'active':isAgeClicked}" (click)="toggleSlider('age')">
                 <span>Age: 
                  <span class="valuespan" *ngIf="minAgeValue == 0 && maxAgeValue == 100">0-100</span>
                  <span class="valuespan" *ngIf="minAgeValue != 0 || maxAgeValue != 100">{{minAgeValue}}-{{maxAgeValue}}</span>
                 </span>
               </div>
               <div class="Confidencedropdown" id="ageId" [ngClass]="{'active':isAgeClicked}">
                  <div class="ConfidenceBdy">
                    <span class="TitleConf">Age</span>
                    <div class="DragSliderHld">
                      <ngx-slider class="Filter-ngx" [(value)]="minAgeValue" [(highValue)]="maxAgeValue" [options]="optionsAge"></ngx-slider>
                    </div>
                  </div> 
                  <div class="Confidencedropftr">
                      <button class="StoltBtnIconLarge position-relative overflow-hidden" (click)="inprogressFilterChange('age')">Apply</button>
                      <button class="StoltBtnIconLarge StoltBtnBorderOnly" (click)="resetSlider('age')">Reset</button>
                  </div>
               </div>
               
             </div> 
           </div> 
           <button (click)="exportExcel()" class="StoltBtnIconLarge" [disabled]="isDisabled">
            Download Excel 
            <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.75 7.40625C6.75 7.1875 6.5625 7.03125 6.375 7.03125H5.625C5.40625 7.03125 5.25 7.1875 5.25 7.40625V10.0312H3.71875C3.375 10.0312 3.21875 10.4375 3.4375 10.6562L5.6875 12.9062C5.84375 13.0625 6.125 13.0625 6.28125 12.9062L8.53125 10.6562C8.75 10.4375 8.59375 10.0312 8.25 10.0312H6.75V7.40625ZM11.5312 3.0625L8.90625 0.46875C8.625 0.1875 8.25 0 7.875 0H1.46875C0.65625 0.03125 0 0.6875 0 1.53125V14.5312C0 15.3438 0.65625 16 1.46875 16H10.4688C11.3125 16 12 15.3438 12 14.5312V4.125C12 3.75 11.8125 3.34375 11.5312 3.0625ZM7.96875 1.625L10.375 4.03125H7.96875V1.625ZM10.5 14.5312H1.46875V1.53125H6.46875V4.78125C6.46875 5.1875 6.8125 5.53125 7.21875 5.53125H10.5V14.5312Z" fill="white"/>
            </svg> 
          </button>
           </div> 
     
      
      <div *ngIf="mapView" class="MapViewHolder">
        <app-agm-map [mapType]="'All'" [User]="User" [centerLat]="fullMapLat" [centerLong]="fullMapLong" [laycanStart]="laycanStart" [laycanEnd]="laycanEnd" [weekType]="weekType"></app-agm-map>
        <!--<agm-map [restriction]="worldMapRestriction" [fitBounds]="true" class="DashboardDataMap" [minZoom]="1" [styles]="styles" [latitude]='lat' [longitude]='long' >
          <agm-marker *ngFor="let marker of User;"
              [latitude]="marker.current_lat" 
              [longitude]="marker.current_lon"
              (markerClick)="markerClick(infoWindow,$event,marker.mmsid)"
              [agmFitBounds]="true"
              [iconUrl] ="{
                path: 'm0.812665,23.806608l37.937001,-22.931615l-21.749812,38.749665l1.374988,-17.749847l-17.562177,1.931797z',
                fillColor: 'green',
                fillOpacity: 1.0,
                scale: .5,
                strokeColor: 'green',
                rotation: marker.heading
            }" [agmFitBounds]="true">
            <agm-info-window [disableAutoPan]="false" #infoWindow>-->
              <!-- <div style="width:160px">
                  <label class="toolHead">Name: </label><a (click)="onClickInfoView({id:m.id})" class="">{{marker.Ship}} <i class="fa fa-angle-double-right"></i></a><br>
                  <label class="toolHead">Owner: </label><a (click)="onClickInfoView({id:m.id})" class="">{{marker.master_operator}} <i class="fa fa-angle-double-right"></i></a><br>
                  <label class="toolHead">DWT: </label><a (click)="onClickInfoView({id:m.id})" class="">{{marker.DWT|
                      number}} <i class="fa fa-angle-double-right"></i></a><br>
                  <label class="toolHead">ETA: </label><a (click)="onClickInfoView({id:m.id})" class="">{{marker.eta_time | date:'yyyy-MM-dd'}} <i class="fa fa-angle-double-right"></i></a><br>
              </div> -->
              <!--<div class="ModelListingData MapModelListingData">
                <div class="modal-dialog modal-dialog-centered my-0">
                  <div class="modal-content p-0 border-0"> 
                    <div class="modal-body">
                       <div class="col-left" *ngIf="metaData && metaData.Ship">
                           <span class="common-heading-bold">{{metaData && metaData.Ship ? metaData.Ship : '-'}}</span>
              
                           <div class="InfoData">
                             <span class="Txt-grey StoltSmallTxt">Load port:</span>
                             <span class="BoldTxt StoltSmallTxt">
                               {{filterData && filterData.stop_port_name ? filterData.stop_port_name : '-' | titlecase}}, 
                               {{filterData && filterData.stop_port_UNlocode ? filterData.stop_port_UNlocode.slice(0,2) : '-'  | uppercase}}</span>
                           </div>
              
                           <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt">Departed on</span>
                            <span class="BoldTxt StoltSmallTxt">
                              {{filterData && filterData.start_port_time ? (filterData.start_port_time | date:'d MMM y') : '-'}}</span>
                          </div>
              
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt">Next port</span>
                            <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.destination ? filterData.destination : '-'}}</span>
                          </div>
              
                          <div class="InfoDataOneline">
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Vessel age</span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.age ? filterData.age : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Tank type </span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.tank_type ? filterData.tank_type : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">No of tanks </span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.Tanks ? filterData.Tanks : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">DWT </span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.DWT ? (filterData.DWT | number) : '-'}}</span>
                            </div>
              
                          </div>
              
              
                          <div class="InfoDataOneline">
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">LOA</span>
                              <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.LOA ? metaData.LOA : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Beam </span>
                              <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.Beam ? metaData.Beam : '-'}}</span>
                            </div>
              
                            <div class="InfoData" *ngIf="trailData">
                              <span class="Txt-grey StoltSmallTxt">Draft (Current)</span>
                              <span class="BoldTxt StoltSmallTxt">
                                {{trailData && trailData.length && trailData[0].draught ? trailData[0].draught : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Draft (@ Summer LL) </span>
                              <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.Draft ? metaData.Draft : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Total cubic capacity </span>
                              <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.CBM ? (metaData.CBM | number) : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Nitrogen generator</span>
                              <span class="BoldTxt StoltSmallTxt">Unknown</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Max heat temp °C </span>
                              <span class="BoldTxt StoltSmallTxt">Unknown</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Min cool temp °C  </span>
                              <span class="BoldTxt StoltSmallTxt">Unknown</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Max carriage press</span>
                              <span class="BoldTxt StoltSmallTxt">Unknown</span>
                            </div>
              
                          </div>
              
                       </div>-->
              
                       <!-- Modal Skeleton Sec-->  
                       <!--<div class="col-left" *ngIf="!metaData || !metaData.Ship">
                        <span class="common-heading-bold Stolt-Skeleton"></span>
                        <div *ngFor="let number of [0,1,2]">
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton"></span>
                            <span class="BoldTxt StoltSmallTxt Stolt-Skeleton"></span>
                          </div> 
                        </div>
              
                        <div class="InfoDataOneline"> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div>
              
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>
              
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>
              
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div> 
                        </div>
              
                        <div class="InfoDataOneline"> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div>            
                        </div>  
                       </div>-->
                       <!--Modal Skeleton Sec End -->
              
                       <!--<div class="col-right col-right-map" *ngIf="metaData && metaData.Ship">
                         <div class="MapCol"> 
                             <img src="assets/images/dummy-map.png" alt="">
                         </div>
              
                         <div class="rightcoldata">
                          <div class="InfoDataOneline spacebtm">
                              <div class="InfoData">
                                <p>
                                  <small class="Txt-grey">Region</small>
                                  <span class="BoldTxt StoltSmallTxt">Region 1</span> 
                                </p>
              
                                <p>
                                  <small class="Txt-grey">ETA into Region</small>
                                  <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.eta_time ? (filterData.eta_time | date:'d MMM y') : '-'}}</span> 
                                </p>
              
                                <p>
                                  <small class="Txt-grey">Confidence</small>
                                  <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.probability ? (filterData.probability | number : '1.0-0' )+'%' : '-'}}</span> 
                                </p>
                                 
                              </div>                
                          </div>
              
                          <div class="InfoDataOneline"> 
              
                            <div class="InfoData">
                              <p class="ThreeCol">
                                <small class="BoldTxt">Previous ports</small>
                                <span class="Txt-grey StoltSmallTxt" *ngFor="let marker of trailData;">
                                  {{marker.stop_port_name | titlecase}}, {{marker.stop_port_UNlocode.slice(0,2)  | uppercase}}
                                </span>
                              </p>
              
                              <p class="ThreeCol">
                                <small class="BoldTxt">Laytime</small>  
                                <span class="Txt-grey StoltSmallTxt" *ngFor="let marker of trailData;">
                                  {{marker.arrivalTime | date:'d MMM':'UTC' }}-{{marker.departureTime | date:'d MMM':'UTC'}}
                                </span> 
                              </p>
              
                              <p class="ThreeCol">
                                <small class="BoldTxt">Draft at port</small>
                                <span class="Txt-grey StoltSmallTxt valuetxt" *ngFor="let marker1 of trailData;">
                                  {{marker1.draught ? marker1.draught : 'N/A'}}
                                </span>
                              </p> 
              
                            </div> 
              
                        </div>
              
                         </div>
                       </div>-->
              
                       <!-- Modal Skeleton Sec   -->
                       <!--<div class="col-right SkeletonRight col-right-map" *ngIf="!metaData || !metaData.Ship">
                        <div class="MapCol Stolt-Skeleton"></div>
              
                        <div class="rightcoldata">
                         <div class="InfoDataOneline spacebtm">
                             <div class="InfoData">
                               <p class="Stolt-Skeleton w-30"> </p> 
                               <p class="Stolt-Skeleton w-30"> </p> 
                               <p class="Stolt-Skeleton w-30"> </p> 
                             </div>                
                         </div>
              
                          <div class="InfoDataOneline">  
                            <div class="InfoData" *ngFor="let number of [0,1,2,3,4,5,6,7,8,9,10,11,12]">
                              <p class="ThreeCol Stolt-Skeleton w-30"> </p>
                              <p class="ThreeCol Stolt-Skeleton w-30"> </p>
                              <p class="ThreeCol Stolt-Skeleton w-30"> </p> 
                            </div>  
                          </div> 
                        </div>
                      </div>-->
                      <!--Modal Skeleton Sec End -->
              
                    <!--</div> 
                  </div>
                </div>
              </div>
            </agm-info-window>
          </agm-marker>
        </agm-map>-->
        <!-- <app-map-container></app-map-container>
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3635689.793072721!2d80.8833819!3d27.141237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1650019992531!5m2!1sen!2sin" width="100%" height="716" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
      </div>
      <div class="TableWrapper">
       <table class="table" *ngIf="!mapView">
           <thead class="StickyThead" *ngIf="!showTableSkel">
               <tr>
                   <th>
                     <span class="TheadeContent column-w-112">
                       Confidence
                      <!--  <svg-icon name="list-view"></svg-icon> -->
                       <span
                                    [ngClass]="{'shortingIcons': true,
                        'active': sortInprogress.probability.isActive,
                        'ascending-icon':sortInprogress.probability.isActive && sortInprogress.probability.value === 'asc','descending-icon':sortInprogress.probability.isActive && sortInprogress.probability.value === 'desc'}"
                                    (click)="toogleSortingOrder('probability')">
                                    <svg-icon name="asc-dsc"></svg-icon>
                                    <app-sorting *ngIf="sortInprogress.probability.isOpen"
                                        [isActive]="sortInprogress.probability.isActive"
                                        [data]="[{ 'name': 'Ascending', 'val': 'asc' }, { 'name': 'Descending', 'val': 'desc' }]"
                                        [sortType]="sortInprogress.probability.value" [colName]="'probability'"
                                        (sortingType)="fetchSortingType($event)"
                                        (popUpMouseOut)="popUpMouseLeaveClose($event)"></app-sorting>
                                </span> 

                   </span>                
                   </th>
                   <th><span class="column-w-160">Vessel</span></th>
                   <th><span class="column-w-152">Operator</span></th>  
                   <th>
                     <span class="TheadeContent column-w-56">
                       DWT
                       <span
                                    [ngClass]="{'shortingIcons': true,
                        'active': sortInprogress.DWT.isActive,
                        'ascending-icon':sortInprogress.DWT.isActive && sortInprogress.DWT.value === 'asc','descending-icon':sortInprogress.DWT.isActive && sortInprogress.DWT.value === 'desc'}"
                                    (click)="toogleSortingOrder('DWT')">
                                    <svg-icon name="asc-dsc"></svg-icon>
                                    <app-sorting *ngIf="sortInprogress.DWT.isOpen"
                                        [isActive]="sortInprogress.DWT.isActive"
                                        [data]="[{ 'name': 'Ascending', 'val': 'asc' }, { 'name': 'Descending', 'val': 'desc' }]"
                                        [sortType]="sortInprogress.DWT.value" [colName]="'DWT'"
                                        (sortingType)="fetchSortingType($event)"
                                        (popUpMouseOut)="popUpMouseLeaveClose($event)"></app-sorting>
                                </span>
                   </span>                    
                   </th>                      
                   <th class="text-end"><span class="column-w-32">Age</span></th>
                   <th class="text-end"><span class="column-w-48">Tanks</span></th>
                   <th><span class="column-w-112">Tank type</span></th>
                   <th>
                     <span class="TheadeContent column-w-128">
                       ETA
                       <span
                                    [ngClass]="{'shortingIcons': true,
                        'active': sortInprogress.eta_time.isActive,
                        'ascending-icon':sortInprogress.eta_time.isActive && sortInprogress.eta_time.value === 'asc','descending-icon':sortInprogress.eta_time.isActive && sortInprogress.eta_time.value === 'desc'}"
                                    (click)="toogleSortingOrder('eta_time')">
                                    <svg-icon name="asc-dsc"></svg-icon>
                                    <app-sorting *ngIf="sortInprogress.eta_time.isOpen"
                                        [isActive]="sortInprogress.eta_time.isActive"
                                        [data]="[{ 'name': 'Ascending', 'val': 'asc' }, { 'name': 'Descending', 'val': 'desc' }]"
                                        [sortType]="sortInprogress.eta_time.value" [colName]="'eta_time'"
                                        (sortingType)="fetchSortingType($event)"
                                        (popUpMouseOut)="popUpMouseLeaveClose($event)"></app-sorting>
                                </span>
                   </span>                    
                   </th>  
                   <th><span class="column-w-168">Last port</span></th>
                   <th><span class="column-w-168">Next port</span></th>
               </tr>
           </thead>
           <tbody *ngIf="!showTableSkel">
               <tr *ngFor="let element of User | sort:sortingFieldType:sortingFieldName;" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="onClickVesselDetails(element.imo)">  
                   <td><span class="column-w-112">{{ (weekType == 0) ? '--' : (element.probability | number : '1.0-0') + '%' }}</span></td> 
                   <td><span [title]="element.Ship" class="column-w-160">{{element.Ship}}</span></td> 
                   <td><span [title]="element.master_operator" class="column-w-152">{{element.master_operator}}</span></td> 
                   <td><span class="column-w-56">{{element.DWT | number}}</span></td> 
                   <td class="text-end"><span class="column-w-32">{{ (element.age == 0) ? "&lt;1" : element.age}}</span></td> 
                   <td class="text-end"><span class="column-w-48">{{element.Tanks}}</span></td> 
                   <td><span [title]="element.tank_type" class="column-w-112">{{element.tank_type}}</span></td> 
                   <td><span class="column-w-128">{{element.eta_time | date:'dd/MM/yyyy'}}</span></td>
                   <td><span  class="column-w-168" *ngIf="element.stop_port_name && element.stop_port_country_code_3" title="{{element.stop_port_name | titlecase}}, {{element.stop_port_country_code_3  | uppercase}}">{{element.stop_port_name | titlecase}}, {{element.stop_port_country_code_3  | uppercase}}</span></td> 
                   <td><span  class="column-w-168" *ngIf="element.destination && element.destination_country_code_3 " title="{{element.destination | titlecase}}, {{element.destination_country_code_3 | uppercase}}">{{element.destination | titlecase}}, {{element.destination_country_code_3 | uppercase}}</span></td>   
               </tr>
               <tr *ngIf="!User || !User.length">
                 <td colspan="10" align="center"><span class="ErroeFound">No. Record Found</span></td>
               </tr>     
           </tbody>
       </table> 
       </div>
      <!-- Table Skelton Start Here --> 
      <div class="SkeltonTableHolder" *ngIf="showTableSkel">
        <table class="table">
            <thead class="StickyThead">
                <tr>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                    <th class="align-middle"><span class="Stolt-Skeleton"></span></th>
                </tr>
            </thead> 
            <tbody>
                <ng-container>
                    <tr *ngFor="let number of [0,1,2,3,4,5,6,7,8,9,10,11,12]">
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                        <td><span class="Stolt-Skeleton"></span></td>
                    </tr>

                </ng-container>
            </tbody>
        </table> 
      </div>
      <!-- Table Skelton Start End -->

       </div>
    </div>
    <div *ngIf="isChecked===true">
      <!-- <app-map-container></app-map-container> -->
    </div>
  </div>
  </div>
</div>

</div>




<!-- Modal -->
<div *ngIf="metaData" class="modal fade ModelListingData" [id]="exampleModalVar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content"> 
      <div class="modal-body">
         <div class="col-left" *ngIf="metaData && metaData.Ship">
             <span class="common-heading-bold">{{metaData && metaData.Ship ? metaData.Ship : '-'}}</span>


              <div class="journey-track">
                  <div class="journey-track-inner journey-line">
                    <h2 class="common-heading-bold"> <span class="RectanglePoint active">
                      <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.35355 4.35331C9.12886 -0.421993 16.8711 -0.421993 21.6464 4.35331C26.4217 9.12861 26.4217 16.8709 21.6464 21.6462L13 30.2926L4.35355 21.6462C-0.421751 16.8709 -0.421748 9.12861 4.35355 4.35331Z" fill="white" stroke="#008ECF"/>
                      </svg> 
                    </span> {{filterData && filterData.stop_port_name ? ((filterData.stop_port_name | titlecase)+', '+(filterData.stop_port_country_code_3 | uppercase)) : '-'}}</h2>
                    <div class="journeyTxt-in">
                      <!-- <span class="Txt-grey StoltSmallTxt Cntry">{{filterData && filterData.stop_port_UNlocode ? filterData.stop_port_UNlocode.slice(0,2) : '-'  | uppercase}}</span> -->
                      <span class="Txt-grey StoltSmallTxt spaceTp8">Departed: {{filterData && filterData.previous_port_call_time ? (filterData.previous_port_call_time | date:'d MMM y') : '-'}}</span>
                      <span class="Txt-grey StoltSmallTxt nextport">AIS reported next port</span>
                    </div> 
                  </div>
                  <div class="journey-track-inner">
                    <h2 class="common-heading-bold"> 
                      <span class="RectanglePoint">
                      <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.35355 4.35331C9.12886 -0.421993 16.8711 -0.421993 21.6464 4.35331C26.4217 9.12861 26.4217 16.8709 21.6464 21.6462L13 30.2926L4.35355 21.6462C-0.421751 16.8709 -0.421748 9.12861 4.35355 4.35331Z" fill="white" stroke="#008ECF"/>
                      </svg> 
                    </span>{{filterData && filterData.destination ? ((filterData.destination | titlecase)+', '+(filterData.destination_country_code_3)) : '-'}}</h2>
                    <div class="journeyTxt-in">
                      <!-- <span class="Txt-grey StoltSmallTxt Cntry">{{filterData && filterData.Country ? filterData.Country : '-'}}</span> -->
                      <!-- <span class="Txt-grey StoltSmallTxt spaceTp8">Est arrival: {{filterData && filterData.eta_time ? (filterData.eta_time | date:'d MMM y') : '-'}}</span>  -->
                      <!-- <span class="PortAddedLeb">
                        <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 0L6.85045 3.64955L10.5 5L6.85045 6.35045L5.5 10L4.14955 6.35045L0.5 5L4.14955 3.64955L5.5 0Z" fill="white"/>
                        </svg> 
                        PortAdded
                      </span> -->
                    </div> 
                  </div>
              </div>

             <!-- <div class="InfoData">
               <span class="Txt-grey StoltSmallTxt">Load port:</span>
               <span class="BoldTxt StoltSmallTxt">
                 {{filterData && filterData.stop_port_name ? filterData.stop_port_name : '-' | titlecase}}, 
                 {{filterData && filterData.stop_port_UNlocode ? filterData.stop_port_UNlocode.slice(0,2) : '-'  | uppercase}}</span>
             </div>

             <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt">Departed on</span>
              <span class="BoldTxt StoltSmallTxt">
                {{filterData && filterData.start_port_time ? (filterData.start_port_time | date:'d MMM y') : '-'}}</span>
            </div>

            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt">Next port</span>
              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.destination ? filterData.destination : '-'}}</span>
            </div> -->

            <div class="InfoDataOneline">

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Operator</span>
                <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.master_operator ? filterData.master_operator : '-'}}</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Vessel age</span>
                <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.age ? filterData.age : '-'}}</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Tank type </span>
                <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.tank_type ? filterData.tank_type : '-'}}</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">No of tanks </span>
                <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.Tanks ? filterData.Tanks : '-'}}</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">DWT </span>
                <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.DWT ? (filterData.DWT | number) : '-'}}</span>
              </div>

            </div>


            <div class="InfoDataOneline">

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">LOA</span>
                <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.LOA ? metaData.LOA : '-'}}</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Beam </span>
                <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.Beam ? metaData.Beam : '-'}}</span>
              </div>

              <div class="InfoData" *ngIf="trailData">
                <span class="Txt-grey StoltSmallTxt">Draft (Current)</span>
                <span class="BoldTxt StoltSmallTxt">
                  {{trailData && trailData.length && trailData[0].draught ? trailData[0].draught : '-'}}</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Draft (@ Summer LL) </span>
                <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.Draft ? metaData.Draft : '-'}}</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Total cubic capacity </span>
                <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.CBM ? (metaData.CBM | number) : '-'}}</span>
              </div>

              <!-- <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Nitrogen generator</span>
                <span class="BoldTxt StoltSmallTxt">Unknown</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Max heat temp °C </span>
                <span class="BoldTxt StoltSmallTxt">Unknown</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Min cool temp °C  </span>
                <span class="BoldTxt StoltSmallTxt">Unknown</span>
              </div>

              <div class="InfoData">
                <span class="Txt-grey StoltSmallTxt">Max carriage press</span>
                <span class="BoldTxt StoltSmallTxt">Unknown</span>
              </div> -->

            </div>

         </div>

         <!-- Modal Skeleton Sec -->
         <div class="col-left" *ngIf="!metaData || !metaData.Ship">
          <span class="common-heading-bold Stolt-Skeleton"></span>
          <div *ngFor="let number of [0,1,2]">
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton"></span>
              <span class="BoldTxt StoltSmallTxt Stolt-Skeleton"></span>
            </div> 
          </div>

          <div class="InfoDataOneline"> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
            </div>

            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
            </div>

            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
            </div>

            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
            </div> 
          </div>

          <div class="InfoDataOneline"> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
            </div> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
            </div> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
            </div> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
            </div> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
            </div>  
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
            </div> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
            </div> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
            </div>  
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
            </div> 
            <div class="InfoData">
              <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
            </div>               
          </div>  
         </div>
         <!-- Modal Skeleton Sec End -->

         <div class="col-right" *ngIf="metaData && metaData.Ship && polygonArr.length">
           <div class="MapCol">
            <p class="Lastupdatetxt">Last position update: {{last_position_update | timeAgo}}</p>
            <google-map class="mapinfoHld" width="100%" [options]="optionsMap" (idle)="initClusterer($event)">
              <map-marker-clusterer   [imagePath]="markerClustererImagePath">
              <ng-container *ngFor='let marker of trailData;;let f = first; let l = last;index as j'>
                <map-marker #markers1="mapMarker" width="100%"
                [position]="{lat:marker.Latitude,lng:marker.Longitude}"
                [options]="{icon : passingPort}" [label]="{color: '#008ECF',
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontWeight: '500',
                text:marker.stop_port_name|titlecase}">
                  <map-info-window>{{marker.stop_port_UNlocode ? (marker.stop_port_UNlocode | uppercase) : ''}}, {{marker.stop_port_name ? (marker.stop_port_name | titlecase) : ''}}</map-info-window>
                </map-marker>
              </ng-container>
            </map-marker-clusterer>

              <!-- Map Highlights Options -->
              <div class="HighlightsBox">
                <div class="HighlightsBoxInner">
                    <div class="OptionsHld">
                        <span>Vessel location</span>
                        <span>
                          <img src="assets/images/svg/Vessel-location.svg"> 
                        </span>
                    </div>
                    <div class="OptionsHld">
                        <span>Completed Voyage</span>
                        <span>
                          <img src="assets/images/svg/Completed-voyage.svg"> 
                        </span>
                    </div>
                    <!-- <div class="OptionsHld">
                        <span>Activity Port</span>
                        <span>
                          <img src="assets/images/svg/Activity-Port-Port.svg"> 
                        </span>
                    </div>  -->
                    <div class="OptionsHld">
                      <span>Passing Port</span>
                      <span>
                        <img src="assets/images/svg/Passing-Port.svg"> 
                      </span>
                    </div>  
                </div>
            </div>
            <!-- Map Highlights Options -->
            <ng-container>
              <map-polygon [options]="{editable:false}">
                <map-polyline [path]="polygonArr" [options]="optionsMap1"></map-polyline>
              </map-polygon>
              <ng-container *ngFor='let loc of mapTrail;let f = first; let l = last;index as j'>
                <map-marker #markers2="mapMarker" *ngIf="l" [position]="{lat:loc?.latitude,lng:loc?.longitude}" [options]="{icon :currentShipIcon}" (mapClick)="openInfoWindow(markers2,infoWindow)">
                  <map-info-window class="brandS-label" #infoWindow="mapInfoWindow"> 
                    <!-- <span>
                      <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg" _ngcontent-rii-c119="" aria-hidden="true">
                      <path d="M16.5245 16.4082H4.44971V0.416619H16.5245V16.4082Z" fill="white" _ngcontent-rii-c119=""></path>
                      <path d="M15.4367 0.415024H19.3567L19.3683 16.4043L12.7249 16.3925C14.5365 15.9348 16.4149 14.0292 16.4195 11.352C16.429 5.64769 8.06708 7.57388 8.04786 4.00519C8.04462 3.3729 8.66263 2.45362 10.3614 2.45802C11.8923 2.46906 12.9457 3.55565 12.9349 5.18821C12.9371 5.19163 15.4367 5.18821 15.4367 5.18821V0.415024Z" fill="#DD1731" _ngcontent-rii-c119=""></path>
                      <path d="M4.99725 16.3984H0.960938L0.97771 0.409039L8.58709 0.420946C6.66405 0.800739 4.63845 2.22844 4.6352 5.39009C4.62844 10.6202 12.8293 9.26296 12.8309 12.2613C12.8312 13.0254 12.243 14.0674 10.3887 14.0462C8.5457 14.0627 7.47716 12.5079 7.46417 10.936C7.462 10.9321 4.99725 10.936 4.99725 10.936V16.3984Z" fill="#DD1731" _ngcontent-rii-c119=""></path>
                      </svg>
                    </span> -->
                    {{filterData.Ship|titlecase}}</map-info-window>
                </map-marker>
              </ng-container>
            </ng-container>
            </google-map>
           </div>

           <div class="rightcoldata">
            <div class="InfoDataOneline spacebtm">
                <div class="InfoData">
                  <p class="RegionHeadingHld"> 
                    <!--<span class="BoldTxt StoltSmallTxt">{{filterData && filterData.region ? (filterData.region) : '-'}}</span> -->
                    <span class="BoldTxt StoltSmallTxt RegionHeading">
                      <em class="MapDot"></em>
                      {{filterData && filterData.region ? (filterData.region) : '-'}}</span>  
                    <span class="tooltip-holder">
                        <a href="#">Other probable regions
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0.25C3.71875 0.25 0.25 3.75 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.25 15.75 15.75 12.2812 15.75 8C15.75 3.75 12.25 0.25 8 0.25ZM8 3.6875C8.71875 3.6875 9.3125 4.28125 9.3125 5C9.3125 5.75 8.71875 6.3125 8 6.3125C7.25 6.3125 6.6875 5.75 6.6875 5C6.6875 4.28125 7.25 3.6875 8 3.6875ZM9.75 11.625C9.75 11.8438 9.5625 12 9.375 12H6.625C6.40625 12 6.25 11.8438 6.25 11.625V10.875C6.25 10.6875 6.40625 10.5 6.625 10.5H7V8.5H6.625C6.40625 8.5 6.25 8.34375 6.25 8.125V7.375C6.25 7.1875 6.40625 7 6.625 7H8.625C8.8125 7 9 7.1875 9 7.375V10.5H9.375C9.5625 10.5 9.75 10.6875 9.75 10.875V11.625Z" fill="#008ECF"/>
                          </svg>                             
                        </a>
                        <span class="tooltpdropBx" [ngClass]="{TopSideOpen: trailData.length < 4}">
                          <ul>
                            <li class="ListHead">
                              <span class="RegionSpan">Region</span>
                              <span class="ETA-region">ETA into region</span>
                              <span>Confidence</span>
                            </li>
                            <li class="Listbody" *ngFor="let i of otherRegionProbabilityData">
                              <span class="RegionSpan">{{i.region}}</span>
                              <span class="ETA-region">{{i.eta ? (i.eta | date:'d MMM y') : '-'}}</span>
                              <span>{{i.totalProbability ? i.totalProbability : 0 }}%</span>
                            </li>
                          </ul>
                        </span>
                    </span>
                  </p>

                  <p class="ETAinto">
                    <small class="Txt-grey justify-content-end">ETA into Region</small>
                    <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.eta_time ? (filterData.eta_time | date:'d MMM y') : '-'}}</span> 
                  </p>

                  <p>
                    <small class="Txt-grey justify-content-end">Confidence</small>
                    <span class="BoldTxt StoltSmallTxt text-end percentxt">{{ (weekType == 0) ? '--' : (filterData.probability | number : '1.0-0' )+'%'}}</span> 
                  </p>
                   
                </div>                
            </div>

            <div class="InfoDataOneline"> 
              <div class="InfoData">
                <p class="ThreeCol">
                  <small class="BoldTxt">Previous ports</small> 
                </p>

                <p class="ThreeCol">
                  <small class="BoldTxt">Laytime</small>   
                </p>

                <p class="ThreeCol">
                  <small class="BoldTxt">Draft at departure</small> 
                </p> 

              </div> 

              <div class="InfoData tableView" *ngFor="let marker of trailData;">
                <p class="ThreeCol"><span class="Txt-grey StoltSmallTxt">{{marker.stop_port_name ? (marker.stop_port_name | titlecase) : ''}}, {{marker.stop_port_UNlocode ? (marker.stop_port_UNlocode | uppercase) : ''}}</span></p>
                <p class="ThreeCol"><span class="Txt-grey StoltSmallTxt">{{marker.arrivalTime | date:'d MMM':'UTC' }}-{{marker.departureTime | date:'d MMM':'UTC'}}</span> </p>
                <p class="ThreeCol"><span class="Txt-grey StoltSmallTxt text-end">{{marker.draught ? marker.draught : 'N/A'}}</span></p>  
              </div>
          </div>

           </div>
         </div>

         <!-- Modal Skeleton Sec -->
         <div class="col-right SkeletonRight" *ngIf="!metaData || !metaData.Ship || !polygonArr.length">
          <div class="MapCol Stolt-Skeleton"></div>

          <div class="rightcoldata">
           <div class="InfoDataOneline spacebtm">
               <div class="InfoData">
                 <p class="Stolt-Skeleton w-30"> </p> 
                 <p class="Stolt-Skeleton w-30"> </p> 
                 <p class="Stolt-Skeleton w-30"> </p> 
               </div>                
           </div>

            <div class="InfoDataOneline">  
              <div class="InfoData" *ngFor="let number of [0,1,2,3,4,5,6,7]">
                <p class="ThreeCol Stolt-Skeleton w-30"> </p>
                <p class="ThreeCol Stolt-Skeleton w-30"> </p>
                <p class="ThreeCol Stolt-Skeleton w-30"> </p> 
              </div>  
            </div> 
          </div>
        </div>
         <!-- Modal Skeleton Sec End -->

      </div> 
    </div>
  </div>
</div>






